<template>
    <div class="page bg-white">
        <div class="cellBox flexStyle">
            <div class="title">类型</div>
            <van-radio-group v-model="model.priceType" direction="horizontal" @change="updatePrice">
                <van-radio name="clerk_grade">等级单</van-radio>
                <van-radio name="game_rank">技术单</van-radio>
            </van-radio-group>
        </div>
        <div class="cellBox">
            <van-cell-group>
                <van-field
                        readonly
                        clickable
                        label="服务类型"
                        :value="gameName"
                        placeholder="选择服务"
                        @click="gamePickerVisible = true"
                />
            </van-cell-group>
        </div>
        <div class="cellBox flexStyle">
            <div class="title">{{model.priceType==='clerk_grade'?'等级':'段位'}}</div>
            <van-radio-group v-if="model.priceType==='clerk_grade'" v-model="model.clerkGradeId" direction="horizontal"
                             @change="updatePrice">
                <van-radio v-for="clerkGrade in validClerkGradeList" :name="clerkGrade.id"
                           :key="clerkGrade.name + clerkGrade.id">{{ clerkGrade.name }}
                </van-radio>
            </van-radio-group>
            <van-radio-group v-if="model.priceType==='game_rank'" v-model="model.gameRankId" direction="horizontal"
                             @change="updatePrice">
                <template v-if="validRankList">
                    <van-radio v-for="rank in validRankList" :name="rank.id" :key="rank.name + rank.id">{{ rank.name }}
                    </van-radio>
                </template>
                <span v-else>请先设置可接段位</span>
            </van-radio-group>
        </div>
        <div class="cellBox">
            <van-cell-group>
                <van-field
                        readonly
                        clickable
                        label="客服"
                        :value="kfName"
                        placeholder="选择客服"
                        @click="kfPickerVisible = true"
                />
            </van-cell-group>
        </div>
        <div class="cellBox">
            <van-cell-group>
                <van-field v-model="model.note" rows="2" maxlength="100" autosize label="订单备注" type="textarea"
                           placeholder="请输入备注（选填）"/>
            </van-cell-group>
        </div>
        <div class="cellBox">
            <van-cell-group>
                <van-cell title="小时单价">
                    {{ formatPrice(model.hourPrice) }}
                </van-cell>
            </van-cell-group>
        </div>
        <div class="cellBox">
            <van-cell-group>
                <van-cell title="小时佣金">
                    {{ formatPrice(model.hourWage) }}
                </van-cell>
            </van-cell-group>
        </div>
        <div>
            <van-button round type="primary" style="width: 100%" @click="submitClick">提交</van-button>
        </div>

        <!-- 选择客服 -->
        <van-popup
                v-model="kfPickerVisible"
                class="datetime-picker-popup"
                position="bottom"
        >
            <van-picker
                    title="客服"
                    show-toolbar
                    :columns="kfList"
                    @confirm="onSelectKfConfirm"
                    @cancel="kfPickerVisible = false"
            />
        </van-popup>

        <!-- 选择服务 -->
        <van-popup
                v-model="gamePickerVisible"
                class="datetime-picker-popup"
                position="bottom"
        >
            <van-picker
                    title="服务"
                    show-toolbar
                    :columns="gameList"
                    @confirm="onSelectGameConfirm"
                    @change="updatePrice"
                    @cancel="gamePickerVisible = false"
            />
        </van-popup>

    </div>
</template>

<script>
import Vue from 'vue';
import {
    Cell,
    CellGroup,
    Popup,
    Search,
    Checkbox,
    CheckboxGroup,
    RadioGroup,
    Radio,
    Field,
    Button,
    Picker,
    Dialog,
    Toast
} from 'vant';
import Decimal from "decimal.js";
import {handlePromise} from "@/libs/util";
import {getPriceSetting, getUploadOrderOptions, uploadOrder} from "@/api/clerk/dispatchOrder";
import _ from 'lodash'

Vue.use(Cell)
    .use(CellGroup)
    .use(Popup)
    .use(Search)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(RadioGroup)
    .use(Radio)
    .use(Field)
    .use(Button)
    .use(Picker)
    .use(Toast)

export default {
    name: 'order-entry',
    data() {
        return {
            kfPickerVisible: false,
            kfName: null,
            kfMap: null,
            kfList: null,
            gamePickerVisible: false,
            gameCategoryList: [],
            gameCategoryRankMap: null,
            rankPriceMap: null,
            gradePriceMap: null,
            clerkGradeList: [],
            gameName: null,
            gameMap: null,
            gameList: null,
            clerkGrade: null,
            clerkGameRankMap: null,
            clerkCarryRankMap: null,
            model: {
                priceType: "clerk_grade",
                gameCategoryId: null,
                kfId: null,
                note: null,
                hourPrice: null,
                hourWage: null,
                clerkGradeId: null,
                gameRankId: null
            },
        }
    },
    computed: {
        rankList() {
            if (this.model.gameCategoryId) {
                return this.gameCategoryRankMap[this.model.gameCategoryId]
            }
            return null
        },
        validRankList(){
            if(this.rankList){
                return _.filter(this.rankList,(elem)=>{
                        return elem.grade <= this.clerkGameRankMap[this.model.gameCategoryId]
                })
            }
            return null
        },
        validClerkGradeList(){
            if(this.clerkGradeList){
                return _.filter(this.clerkGradeList,(elem)=>{
                    return elem.grade <= this.clerkGrade
                })
            }
            return null
        }
    },
    methods: {
        loadData() {
            Toast.loading({
                mask: true,
                message: '加载中...'
            })
            handlePromise(getUploadOrderOptions(), (data) => {
                this.kfMap = new Map()
                this.kfList = []
                for (let kf of data.kfList) {
                    this.kfMap.set(kf.name, kf.id)
                    this.kfList.push(kf.name)
                }
                this.clerkGrade = data.clerkGrade
                this.clerkGameRankMap = data.clerkGameRankMap
                this.clerkCarryRankMap = data.clerkCarryRankMap
                this.gameCategoryList = data.gameCategoryList
                this.gameCategoryRankMap = data.gameCategoryRankMap
                this.rankPriceMap = data.rankPriceMap
                this.gradePriceMap = data.gradePriceMap
                this.clerkGradeList = data.clerkGradeList
                this.model.clerkGradeId = this.clerkGradeList[0].id
                this.model.gameCategoryId = this.gameCategoryList[0].id
                this.model.gameRankId = this.gameCategoryRankMap[this.model.gameCategoryId][0].id
                this.gameMap = new Map()
                this.gameList = []
                for (let game of data.gameCategoryList) {
                    this.gameMap.set(game.name, game.id)
                    this.gameList.push(game.name)
                    if (this.model.gameCategoryId === game.id) {
                        this.gameName = game.name
                    }
                }
                Toast.clear()
            })
        },
        onSelectKfConfirm(val) {
            this.kfName = val
            this.model.kfId = this.kfMap.get(val)
            this.kfPickerVisible = false
        },
        onSelectGameConfirm(val) {
            this.gameName = val
            this.model.gameCategoryId = this.gameMap.get(val)
            this.gamePickerVisible = false
            this.updatePrice()
        },
        updatePrice() {
            let priceSetting = null;
            if (this.model.priceType === 'clerk_grade') {
                priceSetting = this.gradePriceMap[this.model.clerkGradeId]
            } else if (this.model.priceType === 'game_rank') {
                priceSetting = this.rankPriceMap[this.model.gameRankId]
            }
            this.model.hourPrice = priceSetting.hourPrice
            this.model.hourWage = priceSetting.hourWage

        },
        formatPrice(price) {
            if (price != null) {
                return Decimal.div(price, 100).toString()
            }
            return ''
        },
        submitClick() {
            if (this.model.kfId === null) {
                Toast('请选择客服')
                return
            }
            if (this.model.gameCategoryId === null) {
                Toast('请选择服务类型')
                return
            }
            if (this.model.hourPrice === null || this.model.hourWage === null) {
                Toast('请先选择等级或段位')
                return;
            }
            Toast.loading({
                mask: true,
                message: '加载中...'
            })
            uploadOrder(
                this.model.priceType,
                this.model.gameCategoryId,
                this.model.clerkGradeId,
                this.model.gameRankId,
                this.model.kfId,
                this.model.note,
                this.model.hourPrice,
                this.model.hourWage
            ).then(res => {
                Toast.clear()
                const data = res.data
                if (data.code == 0) {
                    Dialog.alert({
                        title: '提示',
                        message: '提交成功'
                    }).then(() => {
                        this.$router.push('/clerk/dispatchOrder/list')
                        this.reset()
                    })
                } else {
                    Dialog.alert({
                        title: '提交失败',
                        message: data.msg
                    })
                }
            })
        },
        reset() {
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>

<style lang="less" scoped>
.page {
  padding: 15px;
}

.cellBox {
  margin: 10px 0;
}

.flexStyle {
  display: flex;
  padding: 10px 16px;
}

.title {
  -webkit-box-flex: 0;
  width: 6.2em;
  color: #646566;
  flex: none;
  margin-right: 12px;
  box-sizing: border-box;
  word-wrap: break-word;
}

.notSelected {
  margin: 0 5px 5px 0;
  padding: 5px;
  border-radius: 5px;
  background: #f5f5f5;
}

.selected {
  margin: 0 5px 5px 0;
  padding: 5px;
  border-radius: 5px;
  background: #07c160;
  color: #fff;
}

.clerkBox {
  border-bottom: 1px #f5f5f5 solid;
  padding: 15px;
}

/deep/ .van-hairline--top-bottom:after {
  border: none;
}

/deep/ .van-field__control {
  background: #f5f5f5;
  padding: 5px;
  border-radius: 5px;
}

/deep/ .van-radio {
  margin-bottom: 5px;
}
</style>
